import { graphql } from '@/gql';
import type { UpdatePartnerCallerMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updatePartnerCaller = async ({ partnerCode, phoneNumber, data }: UpdatePartnerCallerMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      partnerCode,
      phoneNumber,
      data,
    },
    mutation: graphql(`
      mutation UpdatePartnerCaller($partnerCode: String!, $phoneNumber: String!, $data: PartnerCallerInputType!) {
        updatePartnerCaller(partnerCode: $partnerCode, phoneNumber: $phoneNumber, data: $data) {
          callerId
          partnerId
          rides
          credits
          notes
          defaultRideAllowanceTier
          defaultRideAllowanceAmount
          externalPartnerCallerId
          preAuthorizationNumber
          partnerEmergencyContact
          partnerProgramManager
        }
      }
    `),
  });

  return response.data?.updatePartnerCaller;
};
